import React, { useState } from 'react';
import { TIPO_LABELS } from '../data/orientaciones';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const TIPO_SHORT = { apertura:'Apertura', reconocimiento:'Reconoc.', acreditacion:'Acredit.', evaluacion:'Evaluac.', cambio_director:'Cambio Dir.', cambio_secretario:'Cambio Sec.', cambio_nombre:'Cambio Nom.', cambio_direccion:'Cambio Dir. Geo.', cierre_voluntario:'Cierre Vol.', cierre_minerd:'Cierre MINERD', cierre_judicial:'Cierre Jud.', queja_disciplina:'Queja Disc.', queja_colegiatura:'Queja Cole.', otro:'Otro' };

function estadoChip(estado) {
  const map = { Recibido:'chip chip-blue','En proceso':'chip chip-amber',Orientado:'chip chip-green',Cerrado:'chip chip-gray' };
  return <span className={map[estado]||'chip chip-gray'}>{estado}</span>;
}

const TT = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:8, padding:'8px 12px', fontSize:12 }}><div style={{ fontWeight:700 }}>{label}</div><div>Casos: <strong>{payload[0].value}</strong></div></div>;
};

export default function Dashboard({ casos, alerts, onDismissAlert, onNavigate, onVerDetalle, onGenerarPDF }) {
  const [tab, setTab] = useState('tipos');
  const total = casos.length;
  const recibidos = casos.filter(c=>c.estado==='Recibido').length;
  const enProceso = casos.filter(c=>c.estado==='En proceso').length;
  const cerrados = casos.filter(c=>c.estado==='Cerrado').length;
  const orientados = casos.filter(c=>c.estado==='Orientado').length;
  const recientes = [...casos].sort((a,b) => new Date(b.creadoEn||0)-new Date(a.creadoEn||0)).slice(0,6);

  const porTipo = {}; casos.forEach(c => { const t=TIPO_SHORT[c.tipo]||'Otro'; porTipo[t]=(porTipo[t]||0)+1; });
  const dataTipos = Object.entries(porTipo).sort((a,b)=>b[1]-a[1]).slice(0,8).map(([name,value])=>({name,value}));
  const dataEstados = [
    {name:'Recibido',value:recibidos,fill:'#1d4ed8'},{name:'En proceso',value:enProceso,fill:'#b45309'},
    {name:'Orientado',value:orientados,fill:'#15803d'},{name:'Cerrado',value:cerrados,fill:'#6b7280'},
  ].filter(d=>d.value>0);

  const ahora = new Date();
  const meses = Array.from({length:6},(_,i) => {
    const d = new Date(ahora.getFullYear(), ahora.getMonth()-5+i, 1);
    return { label: format(d,'MMM',{locale:es}), mes:d.getMonth(), anio:d.getFullYear(), value:0 };
  });
  casos.forEach(c => {
    if (!c.creadoEn) return;
    const d = new Date(c.creadoEn);
    const m = meses.find(x=>x.mes===d.getMonth()&&x.anio===d.getFullYear());
    if (m) m.value++;
  });
  const dataMeses = meses.map(m => ({ name: m.label.charAt(0).toUpperCase()+m.label.slice(1), value: m.value }));

  return (
    <div>
      {alerts.length > 0 && (
        <div className="alerts-stack">
          {alerts.map(a => (
            <div key={a.id} className={`alert-item ${a.tipo==='urgente'?'alert-red':a.tipo==='proximo'?'alert-amber':'alert-blue'}`}>
              <span><strong>{a.titulo}</strong> — {a.mensaje}</span>
              <button className="alert-close" onClick={()=>onDismissAlert(a.id)}>×</button>
            </div>
          ))}
        </div>
      )}
      <div className="stats-grid">
        <div className="stat-card blue"><div className="stat-num">{total}</div><div className="stat-label">Total de casos</div></div>
        <div className="stat-card red"><div className="stat-num">{recibidos}</div><div className="stat-label">Pendientes</div></div>
        <div className="stat-card gold"><div className="stat-num">{enProceso}</div><div className="stat-label">En proceso</div></div>
        <div className="stat-card green"><div className="stat-num">{cerrados}</div><div className="stat-label">Cerrados</div></div>
      </div>
      <div className="card" style={{ marginBottom:16 }}>
        <div className="card-header">
          <h3>Estadísticas visuales</h3>
          <div style={{ display:'flex', gap:6 }}>
            {[['tipos','Por tipo'],['estados','Por estado'],['meses','Por mes']].map(([k,l]) => (
              <button key={k} onClick={()=>setTab(k)} style={{ padding:'5px 12px', borderRadius:20, fontSize:12, fontWeight:700, cursor:'pointer', border:'none', fontFamily:'inherit', background:tab===k?'linear-gradient(135deg,#002D62,#0a3d80)':'var(--gray-100)', color:tab===k?'#fff':'var(--gray-500)' }}>{l}</button>
            ))}
          </div>
        </div>
        <div style={{ padding:'16px 18px' }}>
          {total === 0 ? <div style={{ textAlign:'center', padding:'40px', color:'var(--gray-400)' }}>Sin datos aún.</div> : (
            <>
              {tab==='tipos' && <ResponsiveContainer width="100%" height={240}><BarChart data={dataTipos} margin={{top:4,right:10,left:0,bottom:40}}><CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6"/><XAxis dataKey="name" tick={{fontSize:10,fill:'#6b7280'}} angle={-30} textAnchor="end" interval={0}/><YAxis tick={{fontSize:11,fill:'#6b7280'}} allowDecimals={false}/><Tooltip content={<TT/>}/><Bar dataKey="value" fill="#002D62" radius={[4,4,0,0]} maxBarSize={48}/></BarChart></ResponsiveContainer>}
              {tab==='estados' && (
                <div style={{ display:'flex', alignItems:'center', gap:20, flexWrap:'wrap' }}>
                  <ResponsiveContainer width={220} height={220}><PieChart><Pie data={dataEstados} cx="50%" cy="50%" innerRadius={55} outerRadius={90} paddingAngle={3} dataKey="value">{dataEstados.map((e,i)=><Cell key={i} fill={e.fill}/>)}</Pie><Tooltip/></PieChart></ResponsiveContainer>
                  <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                    {dataEstados.map(d => (
                      <div key={d.name} style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ width:14, height:14, borderRadius:4, background:d.fill, flexShrink:0 }}/>
                        <div><div style={{ fontSize:13, fontWeight:700 }}>{d.name}</div><div style={{ fontSize:12, color:'var(--gray-500)' }}>{d.value} caso(s) · {Math.round(d.value/total*100)}%</div></div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {tab==='meses' && <ResponsiveContainer width="100%" height={240}><BarChart data={dataMeses} margin={{top:4,right:10,left:0,bottom:4}}><CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6"/><XAxis dataKey="name" tick={{fontSize:12,fill:'#6b7280'}}/><YAxis tick={{fontSize:11,fill:'#6b7280'}} allowDecimals={false}/><Tooltip content={<TT/>}/><Bar dataKey="value" fill="#CE1126" radius={[4,4,0,0]} maxBarSize={56}/></BarChart></ResponsiveContainer>}
            </>
          )}
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h3>Casos recientes</h3>
          <div style={{ display:'flex', gap:8 }}>
            <button onClick={onGenerarPDF} className="btn btn-sm" style={{ background:'linear-gradient(135deg,#CE1126,#a50e1e)', color:'#fff', border:'none', display:'flex', alignItems:'center', gap:6 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5z"/></svg>
              Generar PDF
            </button>
            <button className="btn btn-sm" onClick={()=>onNavigate('casos')}>Ver todos</button>
          </div>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Centro</th><th>Tipo</th><th>Solicitante</th><th>Enviado a</th><th>Estado</th><th>Fecha</th></tr></thead>
            <tbody>
              {recientes.length === 0 ? (
                <tr><td colSpan={6} style={{ textAlign:'center', color:'var(--gray-400)', padding:'32px' }}>Sin casos registrados aún.</td></tr>
              ) : recientes.map(c => (
                <tr key={c.id} onClick={()=>onVerDetalle(c.id)} style={{ cursor:'pointer' }}>
                  <td><strong>{c.centro}</strong>{c.codigoCentro&&c.codigoCentro!=='NUEVO'&&<div style={{marginTop:2}}><span style={{background:'linear-gradient(135deg,#002D62,#0a3d80)',color:'#fff',fontSize:10,fontWeight:700,padding:'1px 7px',borderRadius:20}}>{c.codigoCentro}</span></div>}</td>
                  <td><span className="chip-tipo">{TIPO_LABELS[c.tipo]||c.tipo}</span></td>
                  <td>{c.solicitante}</td>
                  <td>{c.destinatario?<span className="destinatario-tag">→ {c.destinatario}</span>:<span style={{color:'var(--gray-300)',fontSize:12}}>Sin asignar</span>}</td>
                  <td>{estadoChip(c.estado)}</td>
                  <td style={{fontSize:12,color:'var(--gray-500)'}}>{c.fecha?format(parseISO(c.fecha),'dd MMM yyyy',{locale:es}):'—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
